import { c as _c } from "react/compiler-runtime";
import request from '@onefootprint/request';
import type { GetEntityOwnedBusinessIdsRequest, GetEntityOwnedBusinessIdsResponse } from '@onefootprint/types';
import { useQuery } from '@tanstack/react-query';
import type { AuthHeaders } from '@/hooks/use-session';
import useSession from '@/hooks/use-session';
const getBusinessIds = async ({
  entityId
}: GetEntityOwnedBusinessIdsRequest, authHeaders: AuthHeaders) => {
  const {
    data: response
  } = await request<GetEntityOwnedBusinessIdsResponse>({
    headers: authHeaders,
    method: 'GET',
    url: `/entities/${entityId}/businesses`
  });
  return response;
};
const useGetEntityOwnedBusinessIds = id => {
  const $ = _c(9);
  const {
    authHeaders
  } = useSession();
  let t0;
  if ($[0] !== id) {
    t0 = ["entity", id, "owned_business_ids"];
    $[0] = id;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== authHeaders || $[3] !== id) {
    t1 = () => getBusinessIds({
      entityId: id
    }, authHeaders);
    $[2] = authHeaders;
    $[3] = id;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = !!id;
  let t3;
  if ($[5] !== t0 || $[6] !== t1 || $[7] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2
    };
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return useQuery(t3);
};
export default useGetEntityOwnedBusinessIds;